import { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { scroller } from 'react-scroll'

const FocusError = () => {
  const { errors, isSubmitting, isValidating } = useFormikContext()

  useEffect(() => {
    if (isSubmitting && !isValidating) {
      let keys = Object.keys(errors)
      if (keys.length > 0) {
        // const selector = `[name=${keys[0]}]`
        // const errorElement = document.querySelector(selector)
        keys[0] &&
          scroller.scrollTo(keys[0], {
            duration: 300,
            smooth: true,
            offset: -200,
          })
        // if (errorElement) {
        //   errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
        // }
      }
    }
  }, [errors, isSubmitting, isValidating])

  return null
}

export default FocusError
